.selected {
    color: #007bff !important;
    font-weight: bold !important;
}

.industrySearch {
    flex-grow: 1;
    & * {
        font-size: 16px !important;
        font-family: Hanken Grotesk !important;
        border-radius: 10px !important;
        margin: 0 !important;
    }

    & *[class*='btn-close'] {
        box-shadow: none !important;
    }

    & *[class*='rbt-input-multi'] {
        padding: 6px !important;
    }

    & *[class*='rbt-input-main'] {
        padding: 12px !important;
    }

    & *[class*='rbt-input-wrapper'] {
        //height: 45px !important;
        margin: 5px !important;
    }

    & *[class*='rbt-menu dropdown-menu'] {
        transform: translateY(60px) !important	;
    }

    & *[class*='rbt-token'] {
        margin: 5px !important;
        font-size: 14px !important;
        font-family: Hanken Grotesk !important;
        height: 45px !important;
        align-content: center !important;
        text-align: center !important;
        transform: translateY(-5px) !important;
        &:not(:first-child) {
            margin-left: 5px !important	;
        }

        &:first-child {
            margin-left: 0px !important;
        }
    }

    & *[class*='rbt-token-remove-button'] {
        transform: translate(0, 15px) scale(1.5);
    }
    margin-left: 20px !important;
}
